import { render, staticRenderFns } from "./InsertPromotion.vue?vue&type=template&id=77d57bf0&scoped=true"
import script from "./InsertPromotion.vue?vue&type=script&lang=js"
export * from "./InsertPromotion.vue?vue&type=script&lang=js"
import style0 from "./InsertPromotion.vue?vue&type=style&index=0&id=77d57bf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d57bf0",
  null
  
)

export default component.exports